import supplierRecallService from '../../../services/supplier/supplier-recall'
import providerRecallService from '../../../services/provider/recall'
import { ENUM_PRODUCT_FIELD_DATA_TYPE,ENUM_DATE_TYPE_DEFAULT_VALUE } from '../../../misc/commons'
import ProductManager from '../ProductManager'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
    name: 'RecallResponseModal',
    components: {
        ProductManager,
        VueTagsInput
    },
    props: {
        CcEmails: {type: Object, default: []},
        recallData: {
            type: Object,
            default: () => ({})
        },
        communicationType: {
            type: String,
            default: 'RECALL'
        },
        providerCommunicationId: {
            type: String,
        },
        firstCompletedDatetime: {
            type: String,
            default: null
        },
        responseFormData: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            form: {
                recallName: '',
                recallDate: '',
                recallingFirmEmail: '',
                contactInfo: {
                    yourName: '',
                    yourTitle: '',
                    emailAddress: '',
                    telephoneNumber: ''
                },
                facilityInfo: [{
                    providerName: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    zipCode: ''
                }],
                accountCustomerNumber: '',
                affectedProductInInventory: null,
                productDetails: '',
                lotNumbers: '',
                quantity: '',
                additionalProductRows: [],
                affectedProductStatus: null,
                needReturnKit: 'no',
                confirmationReceived: false,
                todaysDate: ''
            },
            additionalFacilities: [],
            isSubmitting: false,
            validationErrors: {},
            filesUpload: [],
            thumbnailIndex: -1,
            // Product management data for step1-products component
            products: [],
            producFieldMetaList: [],
            isLoadingProductFields: false,
            communicationId: null,
            // Store original data for restoration when toggling affected product inventory
            originalRecallData: null,
            originalCommunicationId: null,
            infoData: {
                name: 'Recall Response',
                status: 'OPEN'
            },
            // Supplier Rep Email properties
            valueTag: [],
            enableValueTag: [],
            tag: '',
            emailError: '',
            ccvalue: [],
            autocompleteItems: [],
            originalValueTag: [],
            enumProductFieldDataType: ENUM_PRODUCT_FIELD_DATA_TYPE,
            enumDateTypeDefaultValue: ENUM_DATE_TYPE_DEFAULT_VALUE,
            // Allowed field data types for product fields
            allowedFieldDataTypes: [
                'Item Number',
                'Lot Number',
                'Catalog Number',
                'Serial Number',
                'Product Number',
                'Model'
            ],
            recallResponseId: 0
        }
    },
    computed: {
        isFormValid() {
            const basicFieldsValid = (
                this.form.recallName.trim() !== '' &&
                this.form.recallDate !== '' &&
                // this.form.recallingFirmEmail.trim() !== '' &&
                this.form.contactInfo.yourName.trim() !== '' &&
                this.form.contactInfo.emailAddress.trim() !== '' &&
                this.form.facilityInfo.length > 0 &&
                this.form.facilityInfo[0].providerName.trim() !== '' &&
                this.form.confirmationReceived === true
            )
            return basicFieldsValid
        },
        infoDataCustom() {
            return {
                ...this.infoData,
                isCustomizedContent: true  // This will hide the "Add product" button too
            }
        },
        filteredItemsR() {
            return this.autocompleteItems.filter(i => {
                return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
            })
        },
        todaysDateDisabledDates() {
            // Disable all dates before today
            const yesterday = new Date()
            yesterday.setDate(yesterday.getDate() - 1)
            return {
                to: yesterday
            }
        }
    },
    created() {
        this.getEmailList()
    },
    methods: {
        forceRerenderModel() {
            this.$refs.modal.show()
            this.bindResponseccEmails()
            this.showModal()
        },
        showModal() {
            //this.resetForm()
            if (this.responseFormData && this.responseFormData?.recallResponseId > 0) {
                this.populateFormFromResponseData(this.responseFormData)
            } else {
                // Then populate form data after reset if recallData is available
                if (this.recallData && Object.keys(this.recallData).length > 0) {
                    this.populateFormFromRecallData(this.recallData)
                }
                this.prefillUserInfo()
            }
            this.setTodaysDate()
        },
        bindResponseccEmails()
        {
            this.valueTag=[]
            this.enableValueTag=[]
            this.originalValueTag=[]
            this.options=[]
            this.ccvalue=[]
            var supplierCcEmails=this.CcEmails?.supplierRepCCEmails
            this.defaultEmailList = this.CcEmails?.supplierRepCCEmails
            var additionalRepEmails = this.CcEmails?.additionalCcEmails
            this.combineEmailList = supplierCcEmails?.concat(additionalRepEmails)
            this.combineEmailList?.forEach(x => {
                if (!this.options.includes(x)) {
                    this.options.push(x)
                }
                if (!this.ccvalue?.includes(x)) {
                    this.ccvalue.push(x)
                }
            })
            supplierCcEmails.forEach(x =>
            {
                if (this.valueTag.filter(s=>s.text==x).length<=0) {
                    this.valueTag.push({ 'text': x,'classes': ['ti-tag-disable-close']})
                    this.originalValueTag.push({ 'text': x,'classes': ['ti-tag-disable-close'] })
                    this.disableEmailTagList = true
                }
            })
            additionalRepEmails?.forEach(x =>
            {
                if (this.valueTag.filter(s=>s.text==x).length<=0) {
                    this.enableValueTag.push({'text': x})
                    this.valueTag.push({'text': x})
                }
            })
        },

        // Filter product field metadata to only include allowed data types
        filterAllowedProductFields(productFields) {
            if (!Array.isArray(productFields)) {
                return []
            }
            return productFields.filter(field =>
                field &&
                field.name &&
                this.allowedFieldDataTypes.includes(field.name)
            )
        },

        // Remove non-allowed fields from existing products
        filterProductFields(products) {
            if (!Array.isArray(products)) {
                return []
            }
            return products.map(product => {
                if (!product.fields || !Array.isArray(product.fields)) {
                    return product
                }
                return {
                    ...product,
                    fields: product.fields.filter(field =>
                        field &&
                        field.field_name &&
                        this.allowedFieldDataTypes.includes(field.field_name)
                    )
                }
            })
        },

        hideModal() {
            this.validationErrors = {}
            if (this.$refs.observer) {
                this.$refs.observer.reset()
            }
            this.$refs.modal.hide()
        },

        resetForm() {
            this.form = {
                recallName: '',
                recallDate: '',
                recallingFirmEmail: '',
                contactInfo: {
                    yourName: '',
                    yourTitle: '',
                    emailAddress: '',
                    telephoneNumber: ''
                },
                facilityInfo: [{
                    providerName: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    zipCode: ''
                }],
                accountCustomerNumber: '',
                affectedProductInInventory: null,
                productDetails: '',
                lotNumbers: '',
                quantity: '',
                additionalProductRows: [],
                affectedProductStatus: null,
                needReturnKit: 'no',
                confirmationReceived: false,
                todaysDate: ''
            }
            this.additionalFacilities = []
            this.validationErrors = {}
            this.isSubmitting = false
            this.filesUpload = []
            this.products = []
            this.originalRecallData = null
            this.originalCommunicationId = null
            this.setTodaysDate()
        },

        populateFormFromRecallData(recallData) {
            // Store original recall data for potential restoration
            this.originalRecallData = { ...recallData }

            // Populate recall name
            if (recallData.communicationName) {
                this.form.recallName = recallData.communicationName
            }
            // Populate recall date
            if (recallData.communicationDate) {
                this.form.recallDate = recallData.communicationDate
            }
            // Populate recalling firm email with supplier email
            if (recallData.supplier_email) {
                this.form.recallingFirmEmail = recallData.supplier_email
            } else if (recallData.recalling_firm) {
                // Fallback: Extract email from recalling firm if it contains email
                const emailMatch = recallData.recalling_firm.match(/[\w.-]+@[\w.-]+\.\w+/)
                if (emailMatch) {
                    this.form.recallingFirmEmail = emailMatch[0]
                }
            } else if (recallData.supplier_name && recallData.supplier_name.includes('@')) {
                // Check if supplier name contains email
                this.form.recallingFirmEmail = recallData.supplier_name
            }
            // Set communicationId for fetching product data
            if (recallData.id || recallData.communicationId) {
                this.communicationId = recallData.id || recallData.communicationId
                this.originalCommunicationId = this.communicationId // Store original
                // Fetch product data using the same API as step1_products
                this.fetchCommunicationDetail(this.communicationId)
            }
            if (this.products.length > 0) {
                this.form.affectedProductInInventory = 'yes'
            } else {
                this.form.affectedProductInInventory = 'no'
            }
        },

        populateFormFromResponseData(responseData) {
            if (responseData.id || responseData.communicationId) {
                this.communicationId = responseData.id || responseData.communicationId
                this.originalCommunicationId = this.communicationId // Store original
                // Fetch product data using the same API as step1_products
                this.fetchCommunicationDetail(this.communicationId, true)
            }
            // Store original response data for potential restoration
            this.originalRecallData = { ...responseData }
            this.recallResponseId = responseData.recallResponseId || 0
            // Populate recall information
            if (responseData.recallName || responseData.communicationName) {
                this.form.recallName = responseData.recallName || responseData.communicationName
            }
            if (responseData.recallDate || responseData.communicationDate) {
                this.form.recallDate = responseData.recallDate || responseData.communicationDate
            }
            if (responseData.recallingFirmEmail || responseData.supplier_email) {
                this.form.recallingFirmEmail = responseData.recallingFirmEmail || responseData.supplier_email
            }
            // Populate contact information
            this.form.contactInfo = {
                yourName: responseData.contactName || '',
                yourTitle: responseData.contactTitle || '',
                emailAddress: responseData.contactEmail || '',
                telephoneNumber: responseData.contactPhone || ''
            }
            // Populate facility information
            if (responseData.facilities && Array.isArray(responseData.facilities) && responseData.facilities.length > 0) {
                this.form.facilityInfo = responseData.facilities.map(facility => ({
                    providerName: facility.providerName || '',
                    streetAddress: facility.streetAddress || '',
                    city: facility.city || '',
                    state: facility.state || '',
                    zipCode: facility.zipCode || ''
                }))
            }

            // Populate other form fields
            if (responseData.accountCustomerNumber) {
                this.form.accountCustomerNumber = responseData.accountCustomerNumber
            }
            if (responseData.affectedProductInInventory) {
                this.form.affectedProductInInventory = responseData.affectedProductInInventory
            }
            if (responseData.affectedProductStatus) {
                this.form.affectedProductStatus = responseData.affectedProductStatus
            }
            if (responseData.needReturnKit) {
                this.form.needReturnKit = responseData.needReturnKit
            }
            if (responseData.confirmationReceived !== undefined) {
                this.form.confirmationReceived = responseData.confirmationReceived
            }

            // Populate product details
            if (responseData.productDetails) {
                this.form.productDetails = responseData.productDetails
            }
            if (responseData.lotNumbers) {
                this.form.lotNumbers = responseData.lotNumbers
            }
            if (responseData.quantity) {
                this.form.quantity = responseData.quantity
            }
            if (responseData.products && Array.isArray(responseData.products) && responseData.products.length > 0) {
                this.form.affectedProductInInventory = 'yes'
                // Filter products to remove non-allowed fields
                const filteredProducts = this.filterProductFields(responseData.products)
                this.products = filteredProducts.map((product, index) => ({
                    ...product,
                    quantity: product.quantity || '',
                    unitOfMeasure: product.unitOfMeasure || '',
                    fields: product.fields ? product.fields.map(field => ({
                        ...field,
                        value: typeof field.value === 'object' && field.value !== null
                            ? field.value
                            : this.getDefaultValueForType(field.type || 'Text')
                    })) : [],
                    order: index + 1
                }))
            } else if (this.form.affectedProductInInventory !== 'no') {
                this.form.affectedProductInInventory = 'no'
                this.products = []
            }

            // Set communicationId for future operations
            if (responseData.id || responseData.communicationId) {
                this.communicationId = responseData.id || responseData.communicationId
                this.originalCommunicationId = this.communicationId
            }
        },

        fetchCommunicationDetail(communicationId, isResponseFormSubmitted=false, skipAffectedProductInventoryUpdate=false) {
            if (!communicationId) return Promise.resolve()

            this.isLoadingProductFields = true
            return supplierRecallService.communicationDetail(communicationId).then(res => {
                if (!res.error) {
                    // Extract product field metadata from the communication detail response
                    if (res.data.d.meta_data && res.data.d.meta_data.product_fields) {
                        // Filter to only allowed field data types
                        const allProductFields = res.data.d.meta_data.product_fields
                        this.producFieldMetaList = this.filterAllowedProductFields(allProductFields)
                    }
                    if (!isResponseFormSubmitted) {
                        let _productData = res.data.d.products || []
                        let filteredProductData = this.filterProductFields(_productData)
                        this.products = filteredProductData.map((x, index) => {
                            return {
                                ...x,
                                quantity: x.quantity || '',
                                unitOfMeasure: x.unitOfMeasure || '',
                                fields: x.fields.map(y => {
                                    let _val = y.value
                                    // Ensure proper value structure based on field type
                                    if (typeof _val === 'object' && _val !== null) {
                                    // Value is already structured, use as is
                                        _val = y.value
                                    } else {
                                    // Value is not structured, create proper structure
                                        _val = this.getDefaultValueForType(y.type)
                                        // Set the actual value based on field type
                                        if (y.type === 'Date') {
                                            _val.valueDate = y.value || null
                                        } else if (y.type === 'Number') {
                                            _val.valueNumber = y.value || ''
                                        } else if (y.type === 'Text') {
                                            _val.valueText = y.value || ''
                                        } else {
                                            _val.valueText = y.value || ''
                                        }
                                    }
                                    return {
                                        ...y,
                                        value: _val
                                    }
                                }),
                                order: index + 1
                            }
                        })

                        // Set affected product in inventory based on products (only if not skipped)
                        if (!skipAffectedProductInventoryUpdate) {
                            if (this.products.length > 0) {
                                this.form.affectedProductInInventory = 'yes'
                            } else {
                                this.form.affectedProductInInventory = 'no'
                            }
                        }
                    }
                }
            }).catch(error => {
                console.error('Error fetching communication detail:', error)
                // Fallback: no products found
                this.form.affectedProductInInventory = 'no'
                this.products = []
            }).finally(() => {
                this.isLoadingProductFields = false
            })
        },

        prefillUserInfo() {
            const userInfo = this.$store.state.user
            if (userInfo) {
                if (userInfo.full_name) {
                    this.form.contactInfo.yourName = `${userInfo.full_name}`
                }
                if (userInfo.email) {
                    this.form.contactInfo.emailAddress = userInfo.email
                }
                if (userInfo.phone) {
                    this.form.contactInfo.telephoneNumber = userInfo.phone
                }
                if (userInfo.title) {
                    this.form.contactInfo.yourTitle = userInfo.title
                }
            }
            const facilityInfo = this.$store.state.organization
            if (facilityInfo && this.form.facilityInfo.length > 0) {
                if (facilityInfo.name || facilityInfo.organizationName) {
                    this.form.facilityInfo[0].providerName = facilityInfo.name || facilityInfo.organizationName
                }
                if (facilityInfo.add1) {
                    this.form.facilityInfo[0].streetAddress = facilityInfo.add1
                }
                if (facilityInfo.city) {
                    this.form.facilityInfo[0].city = facilityInfo.city
                }
                if (facilityInfo.state) {
                    this.form.facilityInfo[0].state = facilityInfo.state
                }
                if (facilityInfo.zipCode || facilityInfo.zip) {
                    this.form.facilityInfo[0].zipCode = facilityInfo.zipCode || facilityInfo.zip
                }
            }
        },

        onAffectedProductChange(value) {
            this.form.affectedProductInInventory = value
            // Clear or initialize product details based on selection
            if (value === 'no') {
                this.products = []
                if (this.$refs.productManager) {
                    this.$refs.productManager.reset()
                }
            } else if (value === 'yes') {
                this.isLoadingProductFields = false
                // Re-populate original recall product data
                this.repopulateOriginalProductData()
            }
        },

        repopulateOriginalProductData() {
            // If we have a stored original communicationId, re-fetch the communication details
            if (this.originalCommunicationId) {
                this.communicationId = this.originalCommunicationId // Restore original communicationId
                this.fetchCommunicationDetail(this.originalCommunicationId, false, true)
            }
            // If we have stored original recall data with products, re-populate from that
            else if (this.originalRecallData && this.originalRecallData.products && Array.isArray(this.originalRecallData.products) && this.originalRecallData.products.length > 0) {
                const filteredProducts = this.filterProductFields(this.originalRecallData.products)
                this.products = filteredProducts.map((product, index) => ({
                    ...product,
                    quantity: product.quantity || '',
                    unitOfMeasure: product.unitOfMeasure || '',
                    fields: product.fields ? product.fields.map(field => ({
                        ...field,
                        value: typeof field.value === 'object' && field.value !== null
                            ? field.value
                            : this.getDefaultValueForType(field.type || 'Text')
                    })) : [],
                    order: index + 1
                }))
            }
            // Always ensure at least one product for user to add product information
            else {
                console.log('No original data found, creating default product for user input')
                this.initializeDefaultProduct()
            }
        },

        initializeDefaultProduct() {
            // Create a default product with required fields (filtered to allowed data types)
            const filteredFields = this.filterAllowedProductFields(this.producFieldMetaList)
            const defaultProduct = {
                description: '',
                fields: filteredFields.map(field => ({
                    field_name: field.name,
                    type: field.type,
                    required: field.required,
                    value: this.getDefaultValueForType(field.type)
                })),
                order: 1
            }
            this.products = [defaultProduct]
        },

        getDefaultValueForType(type) {
            switch (type) {
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT:
                return { valueText: '' }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.NUMBER:
                return { valueNumber: '' }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.DATE:
                return { valueDate: null }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_SINGLE:
                return { valueListSingle: null }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_MULTIPLE:
                return { valueListMultiple: [] }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.YES_NO:
                return { valueYesNo: null }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TRUE_FALSE:
                return { valueTrueFalse: null }
            default:
                return { valueText: '' }
            }
        },

        validateFieldValue(field) {
            // Check if field has a valid value based on its type
            if (!field.value) {
                return false
            }
            const fieldMeta = this.producFieldMetaList.find(f => f.name === field.field_name)
            const fieldType = fieldMeta ? fieldMeta.type : ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT

            switch (fieldType) {
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT:
                return field.value.valueText && field.value.valueText.trim() !== ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.NUMBER:
                return field.value.valueNumber && field.value.valueNumber !== ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.DATE:
                return field.value.valueDate !== null && field.value.valueDate !== ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_SINGLE:
                return field.value.valueListSingle !== null && field.value.valueListSingle !== ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_MULTIPLE:
                return field.value.valueListMultiple && Array.isArray(field.value.valueListMultiple) && field.value.valueListMultiple.length > 0
            case ENUM_PRODUCT_FIELD_DATA_TYPE.YES_NO:
                return field.value.valueYesNo !== null
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TRUE_FALSE:
                return field.value.valueTrueFalse !== null
            default:
                return field.value.valueText && field.value.valueText.trim() !== ''
            }
        },
        onProductsChanged(products) {
            if (products && products.length > 0) {
                this.form.affectedProductInInventory = 'yes'
            } else {
                this.form.affectedProductInInventory = 'no'
            }
        },

        handleFieldTypeChange(productIndex, fieldIndex, newFieldName) {
            if (this.products[productIndex] && this.products[productIndex].fields[fieldIndex]) {
                const field = this.products[productIndex].fields[fieldIndex]
                field.field_name = newFieldName
                // Update the field type based on metadata
                const fieldMeta = this.producFieldMetaList.find(f => f.name === newFieldName)
                if (fieldMeta) {
                    field.type = fieldMeta.type
                    field.required = fieldMeta.required || false
                    // Reset value to appropriate type
                    field.value = this.getDefaultValueForType(fieldMeta.type)
                }
            }
        },

        getProductsData() {
            // Get products data from ProductManager component
            if (this.$refs.productManager) {
                return this.$refs.productManager.getProductsData()
            }
            return []
        },

        getFieldType(fieldName) {
            // Get field type from metadata
            const fieldMeta = this.producFieldMetaList.find(f => f.name === fieldName)
            return fieldMeta ? fieldMeta.type : ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT
        },

        formatFieldValue(field) {
            if (!field.value) {
                return ''
            }

            const fieldType = this.getFieldType(field.field_name)
            switch (fieldType) {
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT:
                return field.value.valueText || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.NUMBER:
                return field.value.valueNumber || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.DATE:
                return field.value.valueDate || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_SINGLE:
                return field.value.valueListSingle || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_MULTIPLE:
                return field.value.valueListMultiple ? field.value.valueListMultiple.join(', ') : ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.YES_NO:
                return field.value.valueYesNo !== null ? (field.value.valueYesNo ? 'Yes' : 'No') : ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TRUE_FALSE:
                return field.value.valueTrueFalse !== null ? (field.value.valueTrueFalse ? 'True' : 'False') : ''
            default:
                return field.value.valueText || ''
            }
        },

        addProductRow() {
            this.form.additionalProductRows.push({
                productDetails: '',
                lotNumbers: '',
                quantity: ''
            })
        },

        removeProductRow(index) {
            this.form.additionalProductRows.splice(index, 1)
        },
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return emailRegex.test(email)
        },
        addFacility() {
            this.form.facilityInfo.push({
                providerName: '',
                streetAddress: '',
                city: '',
                state: '',
                zipCode: ''
            })
        },

        removeFacility(index) {
            if (this.form.facilityInfo.length > 1) {
                this.form.facilityInfo.splice(index, 1)
            }
        },

        validateForm() {
            const errors = {}
            if (!this.form.recallName.trim()) {
                errors.recallName = 'Recall name is required'
            }

            if (!this.form.recallDate) {
                errors.recallDate = 'Recall date is required'
            }
            if (!this.form.contactInfo.yourName.trim()) {
                errors.yourName = 'Your name is required'
            }
            // Email validation - check if emails are valid when provided
            if (this.form.recallingFirmEmail && this.form.recallingFirmEmail.trim() !== '') {
                if (!this.isValidEmail(this.form.recallingFirmEmail.trim())) {
                    errors.recallingFirmEmail = 'Please enter a valid recalling firm email address'
                }
            }

            if (this.form.contactInfo.emailAddress && this.form.contactInfo.emailAddress.trim() !== '') {
                if (!this.isValidEmail(this.form.contactInfo.emailAddress.trim())) {
                    errors.contactEmailAddress = 'Please enter a valid contact email address'
                }
            }

            // Supplier Rep Email validation
            if (this.ccvalue && this.ccvalue.length > 0) {
                for (let i = 0; i < this.ccvalue.length; i++) {
                    const supplierEmail = this.ccvalue[i].trim()
                    if (supplierEmail && !this.isValidEmail(supplierEmail)) {
                        errors[`supplierRepEmail_${i}`] = `Supplier Rep Email #${i + 1}: Please enter a valid email address`
                    }
                }
            }

            if (!this.form.facilityInfo.length > 0 || !this.form.facilityInfo[0]?.providerName.trim()) {
                errors.providerName = 'At least one provider name is required for the facility'
            }
            if (!this.form.facilityInfo.length > 0 || !this.form.facilityInfo[0]?.streetAddress.trim()) {
                errors.streetAddress = 'At least one address line 1 is required for the facility'
            }
            if (this.form.affectedProductInInventory === null) {
                errors.affectedProductInInventory = 'Please indicate if you had affected product in inventory'
            }
            // Product validation for affected product in inventory
            if (this.form.affectedProductInInventory === 'yes') {
                // Get current product data from ProductManager component
                const currentProducts = this.getProductsData()

                // Validate that at least one product exists when "yes" is selected
                if (!currentProducts || currentProducts.length === 0) {
                    errors.products = 'Please add at least one product when affected product is in inventory'
                } else {
                    for (let i = 0; i < currentProducts.length; i++) {
                        const product = currentProducts[i]
                        const productPrefix = `Product #${i + 1}`
                        const productDescription = product.description || ''
                        if (!productDescription || productDescription.trim() === '') {
                            // Check if there's a Product Name field with value as fallback
                            const productNameField = product.fields && product.fields.find(field =>
                                field.field_name === 'Product Name' && field.value && this.validateFieldValue(field))
                            if (!productNameField) {
                                errors[`product_${i}_description`] = `${productPrefix}: Product description is required`
                            }
                        }

                        // Validate product fields if they exist
                        if (product.fields && product.fields.length > 0) {
                            for (let j = 0; j < product.fields.length; j++) {
                                const field = product.fields[j]
                                const fieldPrefix = `${productPrefix}, Field #${j + 1}`

                                // Data type is required if field exists
                                if (!field.field_name || field.field_name.trim() === '') {
                                    errors[`product_${i}_field_${j}_type`] = `${fieldPrefix}: Data type is required`
                                } else {
                                    // Data value is required if data type is selected
                                    const hasValue = this.validateFieldValue(field)
                                    if (!hasValue) {
                                        errors[`product_${i}_field_${j}_value`] = `${fieldPrefix}: Data value is required when data type is selected`
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (!this.form.affectedProductStatus || this.form.affectedProductStatus.trim() === '') {
                errors.affectedProductStatus = 'Please confirm how the affected product was handled'
            }
            if (!this.form.needReturnKit || this.form.needReturnKit.trim() === '') {
                errors.needReturnKit = 'Please indicate if you need a return kit'
            }
            if (!this.form.confirmationReceived) {
                errors.confirmationReceived = 'Please confirm that you have received and understood this notice'
            }
            this.validationErrors = errors
            return Object.keys(errors).length === 0
        },
        removevalidation() {
            var ele = this.$refs.response_ccemails.$el.getElementsByClassName('ti-input')
            ele[0].style = ' '
        },
        addemailcolor() {
            var ele = this.$refs.response_ccemails.$el.getElementsByClassName('ti-input')
            ele[0].style = 'border-color:#5ec3ff !important'
        },
        async submitForm() {
            // Validate VeeValidate form fields in RecallResponseModal
            const isRecallFormValid = await this.$refs.observer.validate()

            // Validate ProductManager component if it exists and has products
            let isProductManagerValid = true
            if (this.$refs.productManager && this.form.affectedProductInInventory === 'yes') {
                isProductManagerValid = await this.$refs.productManager.validate()
            }

            // Validate custom form logic
            const customValidationPassed = this.validateForm()

            // If any validation fails, show error and return
            if (!isRecallFormValid || !isProductManagerValid || !customValidationPassed) {
                // Check if there are product-related validation errors
                const hasProductErrors = Object.keys(this.validationErrors).some(key =>
                    key.startsWith('product') || key === 'products'
                )

                // If there are product errors or ProductManager validation failed, open accordion automatically
                if ((hasProductErrors || !isProductManagerValid) && this.form.affectedProductInInventory === 'yes') {
                    // Wait for next tick to ensure DOM is updated
                    this.$nextTick(() => {
                        // Check if the accordion is currently collapsed
                        const collapseElement = document.getElementById('product-manager-collapse')
                        if (collapseElement && !collapseElement.classList.contains('show')) {
                            // Accordion is closed, so toggle it to open
                            this.$root.$emit('bv::toggle::collapse', 'product-manager-collapse')
                        }

                        // Scroll to product section after a short delay to allow accordion to open
                        setTimeout(() => {
                            const productSection = document.querySelector('.product-manager-accordion-wrapper')
                            if (productSection) {
                                productSection.scrollIntoView({ behavior: 'smooth', block: 'center' })
                            }
                        }, 350) // Wait for accordion animation to complete
                    })
                }

                // Show the first specific validation error instead of generic message
                if (!customValidationPassed && Object.keys(this.validationErrors).length > 0) {
                    const firstErrorKey = Object.keys(this.validationErrors)[0]
                    const firstErrorMessage = this.validationErrors[firstErrorKey]
                    this._showToast('Please fill in all required fields correctly', { variant: 'danger' })
                } else if (!isProductManagerValid || !isRecallFormValid) {
                    this._showToast('Please fill in all required fields correctly', { variant: 'danger' })
                }
                return
            }

            // Check if recalling firm email is missing
            if (!this.form.recallingFirmEmail || this.form.recallingFirmEmail.trim() === '') {
                this.showEmailConfirmationModal()
                return
            }
            else{
                this.proceedWithSubmission(true)
            }
        },

        showEmailConfirmationModal() {
            this.$refs.emailConfirmModal.show()
        },

        markCompleteWithoutEmail() {
            this.$refs.emailConfirmModal.hide()
            this.hideModal()
            this.proceedWithSubmission(false)
            // Emit event to parent to mark recall as complete without sending email
            this.$emit('mark-recall-complete', {
                sendEmail: false,
                hasRecallingFirmEmail: false
            })
        },

        cancelEmailConfirm() {
            this.$refs.emailConfirmModal.hide()
        },

        async proceedWithSubmission(sendEmail = true) {
            this.isSubmitting = true
            try {
                const formData = this.prepareSubmissionData()

                // Add email settings to FormData
                formData.append('sendEmail', sendEmail)
                formData.append('hasRecallingFirmEmail', !!this.form.recallingFirmEmail)
                // Call API service to submit recall response
                const response = await providerRecallService.submitRecallResponse(formData,this.recallResponseId,this.communicationId, this.providerCommunicationId)
                if (response.error) {
                    this._showToast('Failed to submit recall response. Please try again.', { variant: 'danger' })
                }
                else{
                    // this._showToast('Recall response submitted successfully', { variant: 'success' })
                    if (sendEmail) {
                        this.$emit('response-submitted', JSON.parse(formData.get('data')))
                    }
                    // // Emit event to refresh parent data after successful submission
                    this.$emit('refresh-recall-data')
                }
                // Hide current modal first
                this.hideModal()
                // Emit response submitted event only if email is being sent
            } catch (error) {
                console.error('Error submitting recall response:', error)
                this._showToast('Failed to submit recall response. Please try again.', { variant: 'danger' })
            } finally {
                this.isSubmitting = false
            }
        },

        openResponseModal(formData, emailSent) {
            // Emit event to parent to open ResponseModal
            this.$emit('open-response-modal', {
                type: 'recall-response',
                data: formData,
                emailSent: emailSent
            })
        },

        prepareSubmissionData() {
            // Create FormData object
            let formData = new FormData()

            // Get advanced product data from custom product management
            let productInfo = {
                details: this.form.productDetails,
                lotNumbers: this.form.lotNumbers,
                quantity: this.form.quantity,
                additionalRows: this.form.additionalProductRows,
            }

            // If using advanced product management, get product data
            if (this.form.affectedProductInInventory === 'yes') {
                const advancedProductData = this.getProductsData()
                // Use the fresh product data from ProductManager component
                if (advancedProductData && advancedProductData.length > 0) {
                    productInfo = {
                        ...productInfo,
                        products: advancedProductData.map(product => ({
                            id: product.id || 0,
                            description: product.description,
                            order: product.order,
                            quantity: product.quantity,
                            unitOfMeasure: product.unitOfMeasure,
                            fields: product.fields ? product.fields.map(field => ({
                                field_name: field.field_name,
                                type: field.type,
                                required: field.required,
                                value: field.value,
                                // Include the actual data type for reference
                                dataType: this.getFieldType(field.field_name),
                                // Include formatted value for easy reading
                                formattedValue: this.formatFieldValue(field)
                            })) : []
                        })),
                        totalProducts: advancedProductData.length
                    }
                }
            }
            formData.append('contactInfo', JSON.stringify(this.form.contactInfo))
            formData.append('accountCustomerNumber', this.form.accountCustomerNumber)
            formData.append('needReturnKit', this.form.needReturnKit ? this.form.needReturnKit : 'No')
            formData.append('confirmationReceived', this.form.confirmationReceived ? this.form.confirmationReceived : 'No')
            formData.append('affectedProductStatus', this.form.affectedProductStatus ? this.form.affectedProductStatus : 'No')
            formData.append('todaysDate', this.form.todaysDate ? this.form.todaysDate : 'No')
            formData.append('recallInfo', JSON.stringify({
                name: this.form.recallName,
                date: this.form.recallDate,
                recallingFirmEmail: this.form.recallingFirmEmail
            }))
            formData.append('recallName', this.form.recallName)
            formData.append('recallDate', this.form.recallDate)
            formData.append('recallingFirmEmail', this.form.recallingFirmEmail)
            formData.append('contactName', this.form.contactInfo?.yourName)
            formData.append('contactEmail', this.form.contactInfo?.emailAddress)
            formData.append('contactPhone', this.form.contactInfo?.telephoneNumber)
            formData.append('contactTitle', this.form.contactInfo?.yourTitle)
            formData.append('facilityInfo', JSON.stringify(this.form.facilityInfo))
            formData.append('affectedProductInInventory', this.form.affectedProductInInventory ? this.form.affectedProductInInventory : 'No')
            formData.append('productInfo', JSON.stringify(productInfo))
            formData.append('communicationType', this.communicationType)
            // Handle file uploads
            this.filesUpload.forEach((x, i) => {
                if (!x.id) {
                    formData.append('document', x.file)
                }
                formData.append('documentInfo[' + i + '].id', x.id ? x.id : 0)
            })
            if (this.ccvalue.length > 0) {
                for (let k = 0; k < this.ccvalue.length; k++) {
                    formData.append('additionalCcEmails', this.ccvalue[k])
                    formData.append('supplierRepCCEmails', this.ccvalue[k])
                }
            }
            return formData
        },

        setTodaysDate() {
            const today = new Date()
            const month = String(today.getMonth() + 1).padStart(2, '0')
            const day = String(today.getDate()).padStart(2, '0')
            const year = today.getFullYear()
            const formattedDate = `${month}/${day}/${year}`
            this.form.todaysDate = formattedDate
        },

        handleFilesUpload() {
            let uploadedFiles = this.$refs.files.files
            for ( let i = 0; i < uploadedFiles.length; i++ ) {
                if(uploadedFiles[i].size == 0){
                    this._showToast('Documented failed to upload. Please try again.', { variant: 'danger' })
                }
                else
                {
                    this.filesUpload.push({
                        file: uploadedFiles[i],
                        note: '',
                        is_thumbnail: false,
                        isAddedBeforeSave: true
                    })
                }
            }
            this.$refs.files.value = ''
        },

        removeDocument(index) {
            this.filesUpload.splice(index, 1)
            this.thumbnailIndex = this.filesUpload.findIndex(x => x.is_thumbnail === true)
        },

        changeRecallStatus() {
            this.$emit('onSubmit','yes')
            this.hideModal()
        },

        addCheck(val) {
            let isDuplicateEmail = false
            let tagArray = []
            let emailArray = []
            this.valueTag = []
            let duplicateEmail = []

            this.originalValueTag.forEach(x => {
                if(emailArray.includes(x.text)) {
                    duplicateEmail.push(x.text)
                    isDuplicateEmail = true
                }
                emailArray.push(x.text)
                tagArray.push(x)
            })

            val.forEach(x => {
                if(x.tiClasses.includes('ti-duplicate')) {
                    duplicateEmail.push(x.text)
                    isDuplicateEmail = true
                }
                if (this.originalValueTag.find(y=>y.text==x.text) == null && !x.tiClasses.includes('ti-duplicate')) {
                    tagArray.push(x)
                }
            })

            val = []
            this.valueTag = tagArray
            val = tagArray

            if(isDuplicateEmail) {
                duplicateEmail.forEach(x => {
                    val.push(x)
                })
                this.setvalidation()
                this.emailError = 'The email has been already used.'
            } else {
                if (val.length > 0) {
                    this.ccvalue = []
                    val.forEach(x => {
                        this.checkEmailValidation(x.text)
                        if (!this.emailError) {
                            this.ccvalue.push(x.text)
                        }
                    })
                    if (this.ccvalue.length > 1) {
                        var valueOriginal = this.ccvalue.length
                        var valcurrent = val.length - 1
                        var b = this.isValidEmail(val[valcurrent].text.trim())
                        if (b) {
                            var i = 0
                            for (i = 0; i < valueOriginal - 1; i++) {
                                if (this.ccvalue[i].trim() === val[valcurrent].text.trim()) {
                                    this.setvalidation()
                                    this.emailError = 'The email has been already used.'
                                }
                            }
                        }
                    }
                    this.removevalidation()
                } else {
                    this.ccvalue = []
                    this.removevalidation()
                }
            }
        },

        checkEmailValidation(email) {
            if (!email) {
                this.setvalidation()
                this.emailError = 'Email is required'
            } else { this.emailError = '' }
            if (email) {
                // Removed const re line - now using isValidEmail method
                var b = this.isValidEmail(email.trim())
                this.removevalidation()
                if (!b) {
                    this._showToast('Please enter valid email address', { variant: 'warning' , title: 'Notice'})
                    this.setvalidation()
                }
            }
        },

        setvalidation() {
            this.addemailcolor()
        },


        _showToast(message, options = {}) {
            // Hide any existing toasts before showing new one
            this.$bvToast.hide()
            this.$bvToast.toast(message, {
                title: options.title || 'Notification',
                variant: options.variant || 'info',
                toaster: 'b-toaster-top-center',
                solid: true,
                appendToast: false,
                autoHideDelay: 5000,
                ...options
            })
        },

        getEmailList() {
            providerRecallService
                .GetEmailList(this.$store.state.orgId)
                .then((resp) => {
                    if (!resp.error) {
                        resp.data.d.forEach((val) => {
                            this.autocompleteItems.push({
                                text: val.email
                            })
                        })
                    }
                })
        }
    }
}